var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_vm._v("\n  杭州焱虎网络科技有限公司 ｜ 浙江省杭州市西湖区西溪银泰商业中心2号楼北楼810室 ｜ 浙ICP备19046733号\n")])}
var staticRenderFns = []

export { render, staticRenderFns }